export const ServicePeriodStatus = {
	PUBLISHED: "Published",
	COMPLETED: "Completed",
	DRAFT: "Draft",
} as const;

export type ServicePeriodStatusValue =
	(typeof ServicePeriodStatus)[keyof typeof ServicePeriodStatus];

export const UnitPayoutStatus = {
	SETTLED: "Settled",
	IN_PROGRESS: "In Progress",
	HOLD: "Hold",
	PARTIALLY_PAID: "Partially Paid",
	PAST_DUE: "Past Due",
} as const;

export type UnitPayoutStatusValue =
	(typeof UnitPayoutStatus)[keyof typeof UnitPayoutStatus];

export interface FinancialPropertyListItem {
	id: string;
	name: string;
	totalUnits: number;
	latestServicePeriodLabel: string;
	status: ServicePeriodStatusValue;
	lastUpdatedDate: string;
	approver: string;
	chargesCategory?: string;
}

export interface ServicePeriodListItem {
	id: string;
	propertyId: string;
	periodLabel: string;
	dueDate?: string;
	paidUnitsLabel: string;
	status: ServicePeriodStatusValue;
	createdDate: string;
	lastUpdatedBy: string;
	lastUpdatedDate: string;
	approver: string;
	uploadedAtLabel?: string;
}

export type FinancialTableColumnAlign = "left" | "right";

export interface FinancialTableColumn {
	id: string;
	label: string;
	align?: FinancialTableColumnAlign;
}
